export const queryKeys = {
    "EVOLUTION_VIEW": "EVOLUTION_VIEW"
}